import { AxiosProgressEvent } from 'axios';
import Cookies from 'js-cookie';
import { ExtendFileType } from 'common/types';
import { FosAxiosInstance } from 'common/service/axiosInstances';
const prefix = '/object-upload';
const taskVersionServer = {
  // 提交新版本相关
  addVersionToSS(uuid, task_id, description) {
    const form = new FormData();
    form.append('uuid', uuid);
    form.append('task_id', task_id);
    form.append('description', description || '');
    form.append('token', Cookies.get('RBAC_TOKEN')!);
    return FosAxiosInstance.post<
      any,
      { code: 0; data: { version_id: number; task_id: number } } | { code: number; data: undefined }
    >(`${prefix}/api/version`, form, {
      // adapter,
      headers: {
        Cookies: `RBAC_TOKEN=${Cookies.get('RBAC_TOKEN')}`,
      },
    });
  },
  // 提交新资产
  addArtAssetToSS(params: {
    uuid: string;
    assetName: string;
    price: number;
    assetType: string;
    tags?: string[];
  }): Promise<ExtendAxioResponse<any>> {
    const data = { ...params };
    return FosAxiosInstance.post(`${prefix}/api/addAsset`, data);
  },

  deleteVersionStashOnClose(uuid) {
    // 提交新版本删除中间缓存
    const form = new FormData();
    const blob = new Blob([`Cookies:RBAC_TOKEN=${Cookies.get('RBAC_TOKEN')}`]);
    form.append('token', Cookies.get('RBAC_TOKEN')!);
    // 页面关闭前navigator.sendBeacon请求删除
    navigator.sendBeacon(`/object-upload/api/disc/${uuid}`, blob);
  },
  // uuid标记上传,以便dcc质检服务索引文件
  normalUpload(
    signal,
    file: ExtendFileType,
    uuid: string,
    file_type: string,
    onUploadProgress?: (progressEvent: AxiosProgressEvent) => void,
  ) {
    const form = new FormData();
    form.append('file_name', file?.name);
    form.append('file', file);
    form.append('uuid', uuid);
    form.append('file_path', file?.path! || '');
    form.append('file_type', file_type);
    return FosAxiosInstance.post(`${prefix}/api/disc/upload`, form, {
      onUploadProgress,
      signal,
    });
  },
  chunkUpload(
    signal,
    file: ExtendFileType,
    bufferData: any,
    uuid: string,
    index: number,
    file_type: string,
    shuyuanId: string,
    onSuccess,
    onError,
    onUploadProgress,
  ) {
    const form = new FormData();
    form.append('id', shuyuanId);
    form.append('bufferData', bufferData);
    form.append('file_name', file?.name);
    form.append('timeStamp', shuyuanId);
    form.append('index', index.toString());
    form.append('uuid', uuid);
    form.append('file_path', file?.path! || '');
    form.append('file_type', file_type);
    return FosAxiosInstance.post(`${prefix}/api/disc/upload_chunk`, form, {
      onUploadProgress,
      signal,
    })
      .then(res => {
        const isSuc = (res as any)?.code === 10000;
        if (isSuc) {
          onSuccess(res?.data?.shuyuan_slice); // shuyuan分片标识
          return res.data.shuyuan_slice;
        }
        onError(res);
        return null;
      })
      .catch(e => {
        console.log('chunkUpload error:', JSON.stringify(e));
        onError(e);
        return null;
      });
  },
  chunkSuccess(
    file: ExtendFileType,
    uuid: string,
    shuyuanId: string,
    totalSize: number,
    file_type: string,
    shuyuan_slices,
  ) {
    const form = new FormData();
    const id = shuyuanId;
    const file_name = file?.name;
    const file_path = file?.path || '';
    form.append('file_type', file_type);
    const part_etags = shuyuan_slices;
    return FosAxiosInstance.post(
      `${prefix}/api/disc/upload_success`,
      { id, file_name, uuid, file_path, file_type, part_etags },
      {},
    );
  },
};

export default taskVersionServer;
